interface LogoIconProps {
  className?: string;
  size?: number;
}

export default function LogoIcon({ className = "", size = 16 }: LogoIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19.8881 5.63976C20.3125 5.53478 20.8816 5.56102 21.5988 5.7185C26.9316 6.9357 29.8464 10.0295 30.3531 15.0033C30.5636 17.0669 30.3202 19.0322 29.6161 20.8957C28.9121 22.7592 27.8857 24.3537 26.5336 25.6759C25.1814 26.998 23.5694 28.0512 21.7008 28.8287C19.8322 29.6096 17.8747 30 15.8317 30C13.0979 30 10.5811 29.3307 8.27169 27.9954C5.96222 26.6601 4.13966 24.8425 2.80069 22.5394C1.46173 20.2362 0.790604 17.7264 0.790604 15C0.790604 12.2736 1.46173 9.76378 2.80069 7.46063C4.13966 5.16076 5.96222 3.3399 8.27169 2.00459C10.5779 0.669291 13.0979 0 15.8317 0H30.7906C30.738 0.104987 30.6656 0.259186 30.5702 0.456037C30.4781 0.652887 30.2642 0.997375 29.932 1.48622C29.5997 1.97507 29.2477 2.40486 28.8759 2.77559C28.5042 3.14633 28.014 3.49081 27.4054 3.80577C26.7935 4.12402 26.1585 4.2815 25.494 4.2815H15.8251C12.8544 4.2815 10.3213 5.32808 8.22563 7.4147C6.13 9.50459 5.08384 11.9759 5.08384 14.9934C5.08384 17.956 6.06466 20.4018 8.22563 22.5722C10.7002 24.8415 12.8544 25.7054 15.8251 25.7054C18.7959 25.7054 21.289 24.702 23.4247 22.5722C25.5203 20.4823 26.5665 17.9159 26.5665 14.9934C26.5665 12.6903 25.9743 10.748 24.7965 9.1601C23.6155 7.57218 21.9837 6.40748 19.8881 5.63976Z"
        fill="currentColor"
      />
    </svg>
  );
}
